export function capitalize(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}


export function saveRowToDb(entity, row) {
  sendRequest(`/${entity}s/${row.id}.json`, { "id": row.id, "name": row.name}, function(response) {}, function(response) {}, 'PUT', false)	
}

export async function deleteRowFromDb(entity, row) {
  await fetch(`/api/rows/${row.id}`, { method: "DELETE" })
}

export function update_server(entity, original, field, current, previous) {
  fetch(`/${entity}s/${original.id}.json`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    },
    body: JSON.stringify({
      [entity]: {
        [field]: current.value
      }
    })
  })
  .then(async response => {
    const data = await response.json();

    if (!response.ok) {
      alert("Fehler:\n" + (data?.base?.join("\n") || "Unknown error"));
      current.value = previous; // rollback
      throw new Error(data.base?.join(", ") || "Fehler");
    }

    original[field] = current.value; // persist on success
    return data;
  })
  .catch(error => {
    console.error("Error:", error);
  });
}

export function formatForDateInput(dateStr) {
  return dateStr ? new Date(dateStr).toISOString().slice(0, 10) : ''
}

export function todayISO() {
	return new Date().toISOString().slice(0, 10)
}

export function isHttpSuccess(xhr) {
    return xhr.status >= 200 && xhr.status < 300;
}

export function sendRequest(url, params, onSuccess, onFailure, method='POST', synch = false) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, synch); // false for synchronous

  xhr.setRequestHeader('Content-Type', 'application/json');
  var token = document.querySelector('meta[name="csrf-token"]').content;
  xhr.setRequestHeader('X-CSRF-Token', token);
  
  console.log("sendRequest params=" + JSON.stringify(params));
  xhr.send(JSON.stringify(params));

  //console.log("xhr repsonse text=" + xhr.responseText);
  const response = JSON.parse(xhr.responseText);
  if (isHttpSuccess(xhr)) {
    console.log(response); // Handle successful creation
    onSuccess(response);
    return true;
  } else {
	onFailure(response);
    return false;
  }
}

export function get_data_attr(attr) {
  return JSON.parse(document.getElementById('app').dataset[attr]);
}

export function optionLabel(opts, item) {
  if (opts.length === 0) {
	return item.id
  }
  let opt = opts.find(o => o.id === item.id);
  return opt == null ? item.id : opt.label;
}

export function getRgTitle(row) {
  return row['Rechtsgrundlage _Kürzel_']
}

export function getRgId(row) {
  return row['HMC-Intern']
}

export function getRgPflichtenLabel(row) {
  return "Pflichten-" + getRgTitle(row) + "(id=" + getRgId(row) + ")";
}

export function getRgStandardTextsLabel(row) {
  return "Standard Texts-" + getRgTitle(row) + "(id=" + getRgId(row) + ")";
}

export async function generateExcel(axios, excelurl, toast, isDownloading) {
  console.log("generateExcel=" + excelurl)
  try {
    isDownloading.value = true

	console.log("axios=" + excelurl)
    const response = await axios.get(excelurl, {responseType: 'blob'})

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    // Try to get filename from Content-Disposition header
    let filename = `report.xlsx` // fallback
    const disposition = response.headers['content-disposition']
	if (disposition) {
	  // Check for RFC 5987 UTF-8 encoded filename first
	  let match = disposition.match(/filename\*=UTF-8''([^;\n]+)/i)
	  if (match && match[1]) {
	    filename = decodeURIComponent(match[1])
	  } else {
	    // Fallback: plain ISO-8859-1 filename
	    match = disposition.match(/filename="?([^;\n"]+)"?/i)
	    if (match && match[1]) {
	      // Convert from ISO-8859-1 bytes to UTF-8 string
	      const isoBytes = new Uint8Array(match[1].split('').map(c => c.charCodeAt(0)))
	      filename = new TextDecoder('iso-8859-1').decode(isoBytes)
	    }
	  }
	}
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)

    toast({ title: "Excel", description: "Generiert" })
  } catch (error) {
	console.log(JSON.stringify(error))
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.response?.statusText ||
      "Excel konnte nicht generiert werden."
    toast({ title: "Excel konnte nicht generiert werden", description: message, variant: "destructive" })
  } finally {
    isDownloading.value = false
  }
}

export function formatNameForUser(user) {
  let lname = user.lastname || "Kein Name eingetragen"
  let fname = user.firstname || ""
  return fname + " " + lname
}

export async function applyMatrixChange(axios, toast, customerInfo, rtype, change, by_function) {
  console.log("applyMatrixChange rtype=" + rtype + " change=" + JSON.stringify(change))

  if (customerInfo.is_hoeppner && (rtype === "rechtsgrundlagen" || rtype === "pflichten")) {
	  try {		
		  let comment = ""
		  if (change.event.shiftKey) {
			  comment = prompt("Bitte einen Grund für die Änderung angeben:");		
			  if (comment === null || comment === "") {
			    //alert("Kein Kommentar vorhanden, keine Änderung vorgenommen.");
				  //change.event.target.checked = !change.event.target.checked
			    return
			  }			
		  }
		  const numberAfterDot = Number(change.path.match(/\.(\d+)$/)[1]);
      let url = "/" + rtype + "/togglematrix/" + change.id;
		  await axios.post(url, {"kids" : [numberAfterDot], "comment" : comment})
		  toast({ title: "Zuweisung", description: "aktualisiert" })
	  } catch (error) {
	    const message =
	      error.response?.data?.message || // if your API returns JSON with "message"
	      error.response?.data?.error || // if your API returns JSON with "message"
	      error.response?.statusText ||   // fallback to status text
	      "Zuweisung nicht aktualisiert."
      console.log("message?" + JSON.stringify(error))
	    toast({ title: "Zuweisung nicht aktualisiert", description: message, variant: "destructive" })
	  }
    return
  }
	
	try {
	  let params = {}
	  params["id"] = change.id
	  const numberAfterDot = Number(change.path.match(/\.(\d+)$/)[1]);
	  
	  params[by_function ? "function_id" : "user_id"] = numberAfterDot;
	  params["status"] = change.value; 
    let status_url = "/" + rtype + "/update_status" + (by_function ? "" : "_users")
    console.log("status_url=" + status_url + " params=" + JSON.stringify(params))
	  await axios.post(status_url, params)
	  toast({ title: "Status", description: "aktualisiert" })
	} catch (error) {
	  const message =
	    error.response?.data?.message || // if your API returns JSON with "message"
	    error.response?.data?.error || // if your API returns JSON with "message"
	    error.response?.statusText ||   // fallback to status text
	    "Status nicht aktualisiert."
	    toast({ title: "Status nicht aktualisiert", description: message, variant: "destructive" })
	}
}

export async function sendNotification(axios, toast, customerInfo, rtype, change, by_function) {
  console.log("sendNotification rtype=" + rtype + " row=" + change.id + " col=" + change.path + " change=" + change.value)
 	try {
	  let params = {}
	  params["id"] = change.id
	  const numberAfterDot = Number(change.path.match(/\.(\d+)$/)[1]);
	  
	  params[by_function ? "function_id" : "user_id"] = numberAfterDot;
	  params["status"] = change.value; 
    let status_url = "/" + rtype + "/send_notification" + (by_function ? "" : "_users")
    console.log("status_url=" + status_url + " params=" + JSON.stringify(params))
	  await axios.post(status_url, params)
	  toast({ title: "Benachrichtigung", description: "gesendet" })
	} catch (error) {
	  const message =
	    error.response?.data?.message || // if your API returns JSON with "message"
	    error.response?.data?.error || // if your API returns JSON with "message"
	    error.response?.statusText ||   // fallback to status text
	    "Benachrichtigung nicht gesendet."
	    toast({ title: "Benachrichtigung nicht gesendet", description: message, variant: "destructive" })
	}

}